import { Stack, Typography, styled } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'contexts/auth';
import { Role } from 'const/common';
import { Nav_Setting } from 'assets';
import { TableCustom, TableDataType } from 'app/components/elements/TableCustom';
import { SETTINGS_AREAS, SETTINGS_BASE_PATH } from './const';

const HEADERS = [
  { label: 'Setting Area', width: '32%' },
  { label: 'Description' },
  { label: 'Actions', width: 140 }
];

export const SettingsIndexPage = () => {
  const navigate = useNavigate();
  const { auth } = useAuth();
  const isAdmin = auth?.role === Role.SUPER_ADMIN || auth?.role === Role.ADMIN;

  const areas = SETTINGS_AREAS.filter((area) => !area.restricted || isAdmin);

  const goToArea = (path: string) => navigate(`${SETTINGS_BASE_PATH}/${path}`);

  const rows: TableDataType[] = areas.map((area) => ({
    name: {
      value: (
        <Stack direction="row" alignItems="center" gap={1.5} sx={{ cursor: 'pointer' }}>
          <Nav_Setting width={18} height={18} />
          <AreaLink onClick={() => goToArea(area.path)}>{area.breadcrumbLabel}</AreaLink>
        </Stack>
      )
    },
    description: {
      value: <Typography sx={{ color: '#53627A', fontSize: 14 }}>{area.description}</Typography>
    },
    actions: {
      value: <ActionLink onClick={() => goToArea(area.path)}>Open Settings</ActionLink>
    }
  }));

  return (
    <WrapperPage>
      <TextPath onClick={() => {}}>Path: Settings</TextPath>
      <TitleStyled>Settings</TitleStyled>
      <SubtitleStyled>
        Manage account, workflow, notification and module configuration.
      </SubtitleStyled>
      <SelectTextStyled>Select a setting area to configure.</SelectTextStyled>

      <TableCustom
        data={rows}
        headers={HEADERS}
        handleChooseRow={() => {}}
        styledTableRow={{ cursor: 'default' }}
      />
    </WrapperPage>
  );
};

const WrapperPage = styled(Stack)(() => ({
  width: '100%',
  minHeight: '100vh',
  padding: '28px 40px 48px',
  backgroundColor: '#FFFFFF'
}));

const TextPath = styled(Typography)(() => ({
  fontSize: 14,
  color: '#818181',
  marginBottom: 8
}));

const TitleStyled = styled(Typography)(() => ({
  color: '#226AAA',
  fontSize: '32px',
  fontWeight: 900,
  marginBottom: 8
}));

const SubtitleStyled = styled(Typography)(() => ({
  color: '#53627A',
  fontSize: 15,
  marginBottom: 6
}));

const SelectTextStyled = styled(Typography)(() => ({
  color: '#071E42',
  fontSize: 15,
  fontWeight: 600,
  marginBottom: 24
}));

const AreaLink = styled(Typography)(() => ({
  color: '#1769C2',
  fontSize: 15,
  fontWeight: 700,
  cursor: 'pointer',
  '&:hover': { textDecoration: 'underline' }
}));

const ActionLink = styled(Typography)(() => ({
  color: '#1769C2',
  fontSize: 14,
  fontWeight: 600,
  cursor: 'pointer',
  '&:hover': { textDecoration: 'underline' }
}));
